module.exports = __webpack_public_path__ + "static/img/msp1.7bb448a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/msp1.png
// module id = 8QCi
// module chunks = 0